export const GreenTickSvg = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="price-promise-tick"
  >
    <path
      d="M18.7213 5.03748C20.5867 2.45303 24.6028 4.57138 23.5453 7.58309C26.391 6.16687 28.9664 9.91956 26.6405 12.0917C29.8159 12.1664 30.3625 16.6959 27.297 17.5325C30.0744 19.0832 28.4644 23.3468 25.3662 22.6566C27.1069 25.3277 23.7146 28.3513 21.2878 26.2897C21.5967 29.4688 17.1945 30.5593 15.9974 27.6014C14.8033 30.5593 10.3981 29.4688 10.707 26.2897C8.28017 28.3513 4.88791 25.3277 6.6286 22.6566C3.52745 23.3468 1.92043 19.0832 4.6978 17.5325C1.6323 16.6959 2.17886 12.1664 5.35427 12.0917C3.02841 9.91956 5.60379 6.16388 8.44948 7.58309C7.392 4.57437 11.4081 2.45303 13.2735 5.03748C13.7309 1.87638 18.2638 1.87638 18.7213 5.03748Z"
      fill="#B1DD64"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.8575 19.0291L22.3882 9.08591L23.832 10.4699L12.9144 21.86L8.19436 17.3163L9.58141 15.8754L12.8575 19.0291Z"
      fill="#141414"
    />
  </svg>
);
